import { isSystem, lang } from '@umu/ukit-lang';
import { Checkbox } from 'common/src/components';
import './aglServiceAgreement.scss';

interface IProps {
    siteHost: string;
    isChecked: boolean;
    onChange: (isChecked: boolean) => void;
}

export function AGLServiceAgreement(props: IProps) {
    const { onChange, isChecked } = props;
    const aglTermsLink = `/staticPage/agl-termcondition.html`;

    const termsLink = (text: string) => `<a href="${aglTermsLink}" target="_blank" rel="noreferrer">${text}</a>`;

    const renderContent = () => {
        // CN：服务条款 + 不退款（一次性支付，不涉及自动续费）
        if (isSystem('CN')) {
            return lang('我已阅读并同意{$0}，并确认本数字化商品购买后不支持退款。', termsLink(lang('《AGL服务条款》')));
        }
        // JP：機能利用規約 + 上方「重要事項説明」中的定期購入事项
        if (isSystem('JP')) {
            return lang('{$0}および上記の定期購入に関する重要事項に同意します。', termsLink(lang('AGL 機能利用規約')));
        }
        // EN / EM：补充条款 + 每年自动续费 + 不退款
        return lang(
            'I agree {$0}, and I understand that this subscription will automatically renew annually and is non-refundable.',
            termsLink(lang('AGL Supplemental Terms of Service')),
        );
    };

    return (
        <div className="service-agreement">
            <Checkbox isChecked={isChecked} onChange={onChange} disabledCheck={false}></Checkbox>
            <div className="agreement-content" dangerouslySetInnerHTML={{ __html: renderContent() }} />
        </div>
    );
}
